import axios from "axios"; // 引入axios
import CryptoJS from "crypto-js";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
// 创建axios实例
const service = axios.create({
  baseURL: "", // api的base_url
  timeout: 30000, // 请求超时时间
  transformRequest: [
    function (data, headers) {
      // 对发送的 data 进行任意转换处理
      return JSON.stringify(data);
    },
  ],
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    const loginInfo = JSON.parse(sessionStorage.getItem("loginInfo"));
    const body = config.data;
    const origin = config.data.data.origin;
    Reflect.deleteProperty(config.data.data, "origin");
    // 1. content-md5
    config.headers["Content-MD5"] = CryptoJS.enc.Base64.stringify(
      CryptoJS.MD5(JSON.stringify(body))
    );
    // 2. 固定参数
    config.headers["Content-Type"] = "application/json";
    config.headers["x-pcs-source"] = "external";
    config.headers["x-pcs-date"] = dayjs.utc().format();
    config.headers["x-pcs-apiver"] = "225932";
    // config.headers["x-pcs-nonce"] = "9O1kuqBUQBDWTjAq0vXqhQKHMmA8sqnK";
    config.headers["x-pcs-nonce"] = ((length) => {
      const str =
        "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
      let result = "";
      for (var i = length; i > 0; --i)
        result += str[Math.floor(Math.random() * str.length)];
      return result;
    })(32);
    console.log(config.headers["x-pcs-nonce"], 'config.headers["x-pcs-nonce"]');
    // x-pcs-username

    let shaKey = ""; // sha256key
    if (config.url === "/pcs/v1/dclouduser.account.GetTokenAndLogin") {
      // 登陆
      shaKey = CryptoJS.MD5(CryptoJS.MD5(origin).toString()).toString();
      config.headers["x-pcs-username"] = `account\\${config.data.data.account}`;
    } else {
      config.headers["Authorization"] = `Bearer ${loginInfo.token}`;
      if (
        [
          "/pcs/v1/user.account.Logout",
          "/pcs/v1/user.account.Cancellation",
        ].includes(config.url)
      ) {
        shaKey = CryptoJS.MD5(loginInfo.token).toString();
        config.headers["x-pcs-username"] = `uuid\\${loginInfo.username}`;
      } else {
        shaKey = CryptoJS.MD5("f248cba82e7211e8ac11bc305bc8d849").toString();
        // config.headers[
        //   "x-pcs-username"
        // ] = `default\\f248cba82e7211e8ac11bc305bc8d849`;
        config.headers[
          "x-pcs-username"
        ] = `default\\eed3c2ab2e7211e8ac11bc305bc8d849`;
      }
    }

    // x-pcs-client-ua
    const projectInfo = JSON.parse(sessionStorage.getItem("projectInfo")) || {};
    let { project, appid } = projectInfo;
    // 不带路径参数或者project=Base, appid=dmssbaseapp 为基线， 其他的都为oem项目
    if (!project || !appid || (project === "Base" && appid === "dmssbaseapp")) {
      project = "Base";
      appid = "dmssbaseapp";
    }
    const clientUA = {
      project,
      language: "zh_CN",
      clientVersion: "V1.99.710",
      clientType: "web",
      clientProtocolVersion: "V6.0.0",
      timezoneOffset: "28800",
      appid,
      phoneArea: "1",
    };

    config.headers["x-pcs-client-ua"] = btoa(
      JSON.stringify(clientUA)
    ).toString();

    // x-pcs-signature
    const signStr = `${config.method.toUpperCase()}\n${config.url}\n${
      config.headers["Content-MD5"]
    }\n${config.headers["Content-Type"]}\nx-pcs-apiver:${
      config.headers["x-pcs-apiver"]
    }\nx-pcs-client-ua:${config.headers["x-pcs-client-ua"]}\nx-pcs-date:${
      config.headers["x-pcs-date"]
    }\nx-pcs-nonce:${config.headers["x-pcs-nonce"]}\nx-pcs-username:${
      config.headers["x-pcs-username"]
    }\n`;
    config.headers["x-pcs-signature"] = CryptoJS.enc.Base64.stringify(
      CryptoJS.HmacSHA256(signStr, shaKey)
    ).toString();

    //如果是验证码接口， username头需要修改如下
    // if (config.headers["x-pcs-username"].startsWith("default")) {
    //   config.headers[
    //     "x-pcs-username"
    //   ] = `default\\eed3c2ab2e7211e8ac11bc305bc8d849`;
    // }

    return config;
  },
  (error) => {
    return Promise.error(error);
  }
);

// 响应拦截器
// service.interceptors.response.use(
//   (response) => {
//     const App = _getApp();
//     handleResponseIntercept(response.config);
//     if (response.status === 200) {
//       const { data } = response;
//       if (data.success) {
//         return Promise.resolve(data);
//       } else {
//         App.openLoading().close();
//         // code: TERMINAL_SPECIAL_CODE_BS 不需要同意弹窗提示异常，需要前端单独处理的异常错误
//         // if (data.code !== 'TERMINAL_SPECIAL_CODE_BS') {
//         //   App.$message.error(data.errMsg || App.$t('web_tty_common_unknownErr'))
//         //   return Promise.reject(data)
//         // }
//         // return Promise.resolve(data)
//         App.$message.error(data.errMsg || App.$t("web_tty_common_unknownErr"));
//       }
//     } else {
//       App.openLoading().close();
//       App.$message.error(App.$t("web_tty_common_severErr"));
//       return Promise.reject(response);
//     }
//   },
//   (error) => {
//     const App = _getApp();
//     App.openLoading().close();
//     const response = error.response;
//     if (response) {
//       handleResponseIntercept(response.config || {});
//       if (axios.isCancel(error)) {
//         console.log("已取消的重复请求：" + error.message);
//       } else {
//         // 添加异常处理
//         if (response.status && response.status === 401) {
//           App.$store.dispatch("logout");
//           router.push("/login");
//         } else {
//           App.$message.error(App.$t("web_tty_common_severErr"));
//           return Promise.reject(response);
//         }
//       }
//     }
//   }
// );

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
function get(url, params) {
  return new Promise((resolve, reject) => {
    service
      .get(url, { params: params })
      .then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {Object} headers [请求时携带的参数]
 */
function post(url, params, headers) {
  return new Promise((resolve, reject) => {
    service
      .post(url, params, headers)
      .then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * delete方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
function deleteAjax(url, params) {
  return new Promise((resolve, reject) => {
    service
      .delete(url, { data: params })
      .then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((err) => {
        reject(err);
      });
  });
}

export default {
  get,
  post,
  deleteAjax,
};
